import { createApp } from 'vue';
import App from './App.vue';
import router from "./routes";
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min';
import '../node_modules/bootstrap/dist/css/bootstrap-grid.min.css';
import VueApexCharts from "vue3-apexcharts";
import '../src/assets/fonts/weather-icons/css/weather-icons.min.css';
import Clipboard from 'vue3-clipboard';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import mitt from 'mitt'

const emitter = mitt()

const app = createApp(App);

app.config.globalProperties.emitter = emitter

app.use(router)
app.use(VueApexCharts)
app.use(VueSweetalert2)
app.component('EasyDataTable', Vue3EasyDataTable);
app.use(Clipboard,{
    autoSetContainer: true,
    appendToBody: true,
})
app.mount('#app')
